import { createContext } from 'react';

const ToastContext = createContext({
  push: () => {},
  closeAll: () => {}
});

export default ToastContext;
